import { app } from '../../app';
import { TvBlockProps } from '../../defs/block';
import { CollideEvent, CollideId } from '../../defs/collide';
import type { TvBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { TvEffect } from '../effects/TvEffect';
import { CollideHandler, ICollision } from './ICollision';

export class TvCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: TvBlockEntity;

  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: TvBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    const collider = event.collider;

    // if block collider
    if (collider?.type === 'block') {
      const colliderProps = collider.entity.c.block.props;

      // if basic block collider
      if (colliderProps.type === 'basic') {
        const props = this.entity.c.block.props as TvBlockProps;

        // attack hat if its all color or matches color of collider
        if (props.color === 'all' || props.color === colliderProps.color) {
          this.attack();
          return true;
        }
      }
    }
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    this.attack();
    return true;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;
    const props = this.entity.c.block.props as TvBlockProps;

    // Despawn the block
    despawnBlockEntity(this.scene, this.entity);

    if (props.color === 'all') {
      // Temp sound effect, just to not be mute
      app.sound.play('puzzle-fugu-destroy');
      // Play break animation, block has been cleaned
      new BreakEffect(this.scene, {
        position,
        size: entity.c.block.props,
        color: 0xf6ed4d,
      }).execute();
    } else {
      // Temp sound effect, just to not be mute
      app.sound.play('puzzle-candle-poke');
      // Play tv effect that will spawn the generic tv block
      await new TvEffect(this.scene, {
        subject: this.entity,
      }).execute();
    }
  }
}
